export class Utils {
  public static isStrContainsWord(str: string, word: string) {
    const wordRegEx = new RegExp(`\\b${word}|\b`)

    // search
    if (str.search(wordRegEx) >= 0) {
      return true
    }

    return false
  }

  public static getArrToMap(nameKey: string, arr: any): Map<string, any> {
    let map: Map<string, any> = new Map()

    for (let index = 0; index < arr.length; index++) {
      map.set(`${arr[index][nameKey]}`, arr[index])
    }

    return map
  }

  public static getMapKeyByValue(map: any, searchValue: string) {
    for (let [key, value] of map.entries()) {
      if (value === searchValue) return key
    }
  }

  /**
   * explodeToArr
   * @param {string} listInString
   * @param {string} charSplit
   * @returns {any}
   */
  public static explodeToArr(listInString: string, charSplit = ',') {
    // verification
    if (Utils.isNullOrEmpty(listInString)) {
      return []
    }

    const returnArr = listInString.toString().split(charSplit)

    return returnArr
  }

  /**
   * isNullOrEmpty
   * @param str
   * @returns {boolean}
   */
  public static isNullOrEmpty(valTest: any) {
    // null
    if (Utils.isNull(valTest) || valTest == '') {
      return true
    } else {
      return false
    }
  }

  /**
   * isNull
   * @param str
   * @returns {boolean}
   */
  public static isNull(valTest: any) {
    // null
    if (valTest == null) {
      return true
    } else {
      return false
    }
  }

  /**
   * Is object Id
   * @param objectId
   * @returns
   */
  public static isObjectId(objectId: string): boolean {
    if (objectId.match(/^[0-9a-fA-F]{24}$/)) {
      // it's an ObjectID
      return true
    }

    return false
  }

  public static intersect = (xs: any, ys: any) =>
    xs?.filter((x: any) => ys?.some((y: any) => y === x))

  public static getInnerObjectDataByPath = (object: any, path: string) =>
    path.split('.').reduce((p: any, c: any) => p?.[c], object)

  public static getInitials = (name: string) => {
    let initials
    const nameSplit = name.split(' ')
    const nameLength = nameSplit.length
    if (nameLength > 1) {
      initials = nameSplit[0].substring(0, 1) + nameSplit[nameLength - 1].substring(0, 1)
    } else if (nameLength === 1) {
      initials = nameSplit[0].substring(0, 1)
    } else return

    return initials.toUpperCase()
  }

  public static capitalizeFirstLetter(string: string) {
    return string?.charAt(0).toUpperCase() + string?.slice(1)
  }

  public static capitalizeFirstLetterAndLowerCase(string: string) {
    return string?.charAt(0).toUpperCase() + string?.slice(1).toLowerCase()
  }

  public static isEqualInsensitive(string1: string, string2: string) {
    var areEqual = string1.toUpperCase() === string2.toUpperCase()

    return areEqual
  }

  public static isIncludeInsensitive(string: string, searchString: string) {
    return string.toLowerCase().includes(searchString.toLowerCase())
  }

  public static isContainedInsensitive(arr: string[], searchString: string) {
    return arr.some(element => element.toLowerCase() === searchString.toLowerCase())
  }

  public static roundPrecision(num: any, decimalPlaces: number) {
    var p = Math.pow(10, decimalPlaces)
    var n = num * p * (1 + Number.EPSILON)

    return Math.round(n) / p
  }
}
